import React from 'react'
import './css/ServiceSection.css'

function ServiceSection({title, content, image, reverse}) {
  return (
    <div className='ServiceSection'>
        <h1>{title}</h1>
        <div className={`content ${reverse ? "reverse" : ""}`}>
            <img src={image} alt='Service' />
            <p>{content}</p>
        </div>
    </div>
  )
}

export default ServiceSection